
import React from 'react';

const LegalLayout = ({ title, children }) => (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
        <h1 className="text-3xl font-bold mb-6 text-gray-800">{title}</h1>
        <div className="prose lg:prose-xl text-gray-600">
            {children}
        </div>
    </div>
);

export const TermsPage = () => (
    <LegalLayout title="Terms of Service">
        <p>Last updated: {new Date().toLocaleDateString()}</p>
        <p>Welcome to AI T-Shirt Design. By accessing or using our website, you agree to be bound by these Terms of Service.</p>

        <h3>1. Use of Service</h3>
        <p>You agree to use our AI generation tools responsibly and not to generate content that is illegal, offensive, or violates intellectual property rights.</p>

        <h3>2. Accounts</h3>
        <p>You are responsible for safeguarding the password that you use to access the service and for any activities or actions under your password.</p>

        <h3>3. Intellectual Property</h3>
        <p>The images you generate using our AI tools are unique. We grant you a license to use these images for your personal use and for printing on our products.</p>

        <h3>4. Termination</h3>
        <p>We may terminate or suspend access to our Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.</p>
    </LegalLayout>
);

export const PrivacyPolicyPage = () => (
    <LegalLayout title="Privacy Policy">
        <p>Last updated: {new Date().toLocaleDateString()}</p>
        <p>Your privacy is important to us. It is AI T-Shirt Design's policy to respect your privacy regarding any information we may collect from you across our website.</p>

        <h3>1. Information We Collect</h3>
        <p>We collect information you provide directly to us, such as when you create an account, design a t-shirt, or make a purchase. This includes your name, email address, and shipping information.</p>

        <h3>2. How We Use Information</h3>
        <p>We use the information we collect to operate and maintain our services, process your orders, and communicate with you.</p>

        <h3>3. Cookies</h3>
        <p>We use cookies to help you navigate efficiently and perform certain functions. Detailed information about all cookies can be found under each consent category below.</p>
    </LegalLayout>
);

export const RefundPolicyPage = () => (
    <LegalLayout title="Refund Policy">
        <p>Last updated: {new Date().toLocaleDateString()}</p>
        <p>We want you to be completely satisfied with your purchase. However, because our products are custom-made, we have specific policies regarding repurchases and refunds.</p>

        <h3>1. Damaged or Defective Items</h3>
        <p>If your item arrives damaged or the print quality is poor, please contact us within 30 days of delivery. We will arrange for a free replacement or a full refund.</p>

        <h3>2. Returns for Other Reasons</h3>
        <p>Because every product is custom printed just for you, we cannot offer returns or exchanges for wrong size or buyer's remorse.</p>

        <h3>3. Contact Us</h3>
        <p>If you have any questions about our Refund Policy, please contact us at support@yourshirt.co.</p>
    </LegalLayout>
);
